"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.usePersonalProductListEditContext = exports.personalProductListEditContext = exports.PersonalProductListEditProvider = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file */ const defaultProductListingContextValues = {
    productBoxConfiguration: {},
    isLoadingPersonalProductListDetail: false,
    personalProductListDetail: undefined,
    personalProductListsCount: 0,
    isLoadingProducts: false,
    maximumAllowedPersonalProductLists: 0,
    products: [],
    setProducts: ()=>{},
    isMaximumRecordsReached: false,
    setIsMaximumRecordsReached: ()=>{},
    open: false,
    onClose: ()=>{},
    onOpen: ()=>{}
};
const personalProductListEditContext = exports.personalProductListEditContext = /*#__PURE__*/ (0, _react.createContext)(defaultProductListingContextValues);
const { Provider } = personalProductListEditContext;
const PersonalProductListEditProvider = (param)=>{
    let { children, productBoxConfiguration } = param;
    const { isValidating: isLoading, data: productListData } = (0, _hooks.useGetProductList)();
    const { data: personalProductListsData } = (0, _hooks.useGetPersonalProductLists)();
    var _personalProductListsData_productLists_length;
    const personalProductListsCount = (_personalProductListsData_productLists_length = personalProductListsData === null || personalProductListsData === void 0 ? void 0 : personalProductListsData.productLists.length) !== null && _personalProductListsData_productLists_length !== void 0 ? _personalProductListsData_productLists_length : 0;
    var _personalProductListsData_maximumAllowedRecords;
    const maximumAllowedPersonalProductLists = (_personalProductListsData_maximumAllowedRecords = personalProductListsData === null || personalProductListsData === void 0 ? void 0 : personalProductListsData.maximumAllowedRecords) !== null && _personalProductListsData_maximumAllowedRecords !== void 0 ? _personalProductListsData_maximumAllowedRecords : 0;
    const [products, setProducts] = (0, _react.useState)([]);
    const [isMaximumRecordsReached, setIsMaximumRecordsReached] = (0, _react.useState)(false);
    const { onClose, onOpen, open } = (0, _presentationHooks.useDisclose)();
    var _productListData_items_map;
    const { data: productsData, loading: isLoadingProducts } = (0, _hooks.useGetProducts)({
        productCodes: (_productListData_items_map = productListData === null || productListData === void 0 ? void 0 : productListData.items.map((item)=>{
            var _item_itemCode;
            return (_item_itemCode = item.itemCode) !== null && _item_itemCode !== void 0 ? _item_itemCode : '';
        })) !== null && _productListData_items_map !== void 0 ? _productListData_items_map : [],
        skip: !productListData
    });
    (0, _react.useEffect)(()=>{
        if (productsData !== null) {
            setProducts(productsData.map((product)=>({
                    type: 'product',
                    ...product
                })));
        }
    }, [
        productsData
    ]);
    const value = (0, _react.useMemo)(()=>({
            isLoadingProducts,
            productBoxConfiguration,
            isLoadingPersonalProductListDetail: isLoading,
            personalProductListDetail: productListData,
            personalProductListsCount,
            maximumAllowedPersonalProductLists,
            products,
            setProducts,
            isMaximumRecordsReached,
            setIsMaximumRecordsReached,
            open,
            onClose,
            onOpen
        }), [
        isLoadingProducts,
        productBoxConfiguration,
        isLoading,
        productListData,
        personalProductListsCount,
        maximumAllowedPersonalProductLists,
        products,
        isMaximumRecordsReached,
        open,
        onClose,
        onOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Provider, {
        value: value,
        children: children
    });
};
exports.PersonalProductListEditProvider = PersonalProductListEditProvider;
const usePersonalProductListEditContext = ()=>(0, _react.useContext)(personalProductListEditContext);
exports.usePersonalProductListEditContext = usePersonalProductListEditContext;
